import qs from 'qs';

import Cookie from 'js-cookie';

export type Options = {
  obj?: Record<string, unknown>;
  text?: string;
  url?: string;
  time?: Date;
  getCustomPath?: (params: Record<string, unknown>) => string;
};

export type Meta = {
  query?: Record<string, unknown>;
};

const analyticsParams = [
  'utm_source',
  'utm_term',
  'utm_medium',
  'utm_content',
  'utm_campaign',
  'source',
  'term',
  'medium',
  'content',
  'campaign',
  'srmk',
];

const sendKM = (name: string, options: Options = {}, meta: Meta = {}): Promise<boolean> => {
  const cookieParams = {
    referrer: Cookie.get('referrer'),
    vid: Cookie.get('vid'),
    abst: Cookie.get('abst'),
  };

  const params: Record<string, unknown> = {
    ...cookieParams,
    ...options?.obj,
  };

  if (options.text || options.url) {
    let text = '';

    if (options.text) {
      text += options.text;
    }

    if (options.url) {
      text += `  ${options.url}`;
    }

    params.EventInfo = text;
  }

  if (params.lang) {
    params.locale = params.lang;
  } else {
    params.locale = 'ru';
  }

  if (document?.domain) {
    params.domain = document.domain;
  }

  if (meta.query) {
    for (const paramName of analyticsParams) {
      if (meta.query[paramName]) {
        params[paramName] = meta.query[paramName];
      }
    }
  }

  const time = options.time || new Date();

  // eslint-disable-next-line no-underscore-dangle
  params._n = name;
  // eslint-disable-next-line no-underscore-dangle
  params._t = Math.round(time.getTime() / 1e3);

  return new Promise((resolve) => {
    const zeropixel = new Image();
    const { protocol, host } = window.location;

    zeropixel.onload = () => {
      resolve(true);
    };

    zeropixel.onerror = () => {
      resolve(false);
    };

    if (options.getCustomPath) {
      zeropixel.src = options.getCustomPath(params);
    } else {
      zeropixel.src = `${protocol}//${host}/_api_misc/kismx/e?${qs.stringify(params)}`;
    }
  });
};

export default sendKM;
